import { useState, useEffect } from "react";

/**
 * Hook personalizado para detectar si el dispositivo es móvil
 *
 * @param {number} breakpoint - Ancho de pantalla en píxeles para considerar móvil (default: 768)
 * @returns {boolean} - Retorna true si el ancho de pantalla es menor al breakpoint especificado
 */
export const useMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => window.removeEventListener("resize", checkIsMobile);
  }, [breakpoint]);

  return isMobile;
};
